/** OmniLight3D property formatter: the inspector sections for the light. */
import { formatNode3DProperties } from '../../../base/node3d/propertyFormatter';
import { OMNI_LIGHT_3D_SHADOW_MODE_NAMES } from '../../../../godot/scene/light';
import { formatBaseLightSection, formatShadowSectionWithNormalBias } from '../shared/propertyFormatter';
export function formatOmniLight3DProperties(properties) {
    const sections = [];
    const omniLightItems = [
        { label: 'Range', value: properties.omni_range.toFixed(2) },
        { label: 'Attenuation', value: properties.omni_attenuation.toFixed(2) },
    ];
    sections.push(formatBaseLightSection(properties, omniLightItems));
    const omniShadowItems = [];
    if (properties.omni_shadow_mode !== undefined) {
        omniShadowItems.push({
            label: 'Shadow Mode',
            value: OMNI_LIGHT_3D_SHADOW_MODE_NAMES[properties.omni_shadow_mode] ??
                `Unknown (${properties.omni_shadow_mode})`,
        });
    }
    sections.push(formatShadowSectionWithNormalBias(properties, omniShadowItems));
    sections.push(...formatNode3DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map